import React from 'react';
import YouTube from 'react-youtube';
export var EmbeddedVideo = function EmbeddedVideo(_ref) {
  var video = _ref.video,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay;
  return React.createElement("div", null, React.createElement(YouTube, {
    opts: {
      width: '100%',
      playerVars: {
        autoplay: autoplay ? 1 : undefined
      }
    },
    videoId: video.id
  }));
};